package com.example.readingnotes.data.remote.dto

import kotlinx.serialization.Serializable

/**
 * Purchasable content information
 */
@Serializable
data class PurchasableContentDto(
    val id: String, // UUID
    val postId: String, // UUID
    val tenantId: String, // UUID
    val creatorId: String, // UUID
    val price: Int, // Price in currency units (e.g., JPY)
    val currency: String, // e.g., "JPY", "USD"
    val status: String, // "draft", "active", "inactive"
    val publishedAt: String? = null, // ISO date string
    val createdAt: String,
    val updatedAt: String,
)

/**
 * Content purchase information
 */
@Serializable
data class ContentPurchaseDto(
    val id: String, // UUID
    val contentId: String, // UUID
    val purchaserId: String, // UUID
    val amountPaid: Int,
    val platformFee: Int,
    val creatorEarnings: Int,
    val purchasedAt: String,
    val refundedAt: String? = null,
)

/**
 * Purchase session response (Stripe Checkout)
 */
@Serializable
data class PurchaseSessionDto(
    val checkoutUrl: String,
    val sessionId: String,
    val contentId: String,
    val amount: Int,
    val currency: String,
)

/**
 * Purchase request
 */
@Serializable
data class CreatePurchaseRequestDto(
    val successUrl: String,
    val cancelUrl: String,
)

/**
 * Content access check result
 */
@Serializable
data class ContentAccessResultDto(
    val hasAccess: Boolean,
    val isPurchased: Boolean,
    val isAuthor: Boolean,
    val price: Int? = null,
    val currency: String? = null,
    val purchaseDate: String? = null,
)

/**
 * Set price request
 */
@Serializable
data class SetPriceRequestDto(
    val price: Int,
    val currency: String? = "JPY",
)

/**
 * Sales dashboard data
 */
@Serializable
data class SalesDashboardDto(
    val totalSales: Int,
    val totalRevenue: Int,
    val platformFees: Int,
    val creatorEarnings: Int,
    val salesByContent: List<ContentSalesDto>,
)

/**
 * Sales per content
 */
@Serializable
data class ContentSalesDto(
    val contentId: String,
    val postId: String,
    val title: String, // Post title
    val salesCount: Int,
    val revenue: Int,
)

/**
 * User's purchases list
 */
@Serializable
data class PurchasesListDto(
    val purchases: List<ContentPurchaseDto>,
    val total: Int,
)
